export const BLOCK_COMMON_STYLES: { [key: string]: string } = {
  'font-size': 'var(--global-font-size, 14px)',
  'font-family': 'var(--global-font-family, "Helvetica Neue")',
  color: 'var(--textColor, #333)',
};

export class TextWidgetData {
  innerHtml?: string = `<p style="margin:0;padding:0;">This is a new Text. Click to change the text.</p>`;
}
